module.exports = __webpack_public_path__ + "static/img/Daniel-Atkinson.08213e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Daniel-Atkinson.jpg
// module id = JfYz
// module chunks = 0